import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-application-view',
  templateUrl: './user-application-view.component.html',
  styleUrls: ['./user-application-view.component.css']
})
export class UserApplicationViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/user-application/user-application-view/user-application-view.component.ts